import React from 'react'
import ReactLoading from 'react-loading'
import { withStyles } from 'material-ui/styles'
import styles from './styles'


const Loading = ({ type, color, classes }) => (
  <div className={classes.root}>
    <div className={classes.cover}></div>
    <div className={classes.loading}>
      <ReactLoading type={type} color={color} />
    </div>
  </div>
);


export default withStyles(styles)(Loading)



// WEBPACK FOOTER //
// ./src/components/loading/index.js